import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

// Discreet, accessible contextual help: tappable (mobile), keyboard-focusable, aria-labelled.
// NOT a hover-only tooltip. Used for microcopy that explains Equiro's surprising logics.
export const InfoHint = ({ label, text, testId, side = "top", align = "start", className = "" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={label || "Informazioni"}
        data-testid={testId}
        onClick={(e) => e.stopPropagation()}
        className={`inline-flex items-center justify-center h-4 w-4 shrink-0 rounded-full text-[#8C6D4F] hover:text-[#8C532B] focus:outline-none focus:ring-2 focus:ring-[#8C532B]/40 align-middle ${className}`}
      >
        <Info className="h-3.5 w-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent side={side} align={align} className="w-64 p-3 text-xs leading-relaxed text-[#41504A]"
      data-testid={testId ? `${testId}-content` : undefined}>
      {text}
    </PopoverContent>
  </Popover>
);
